export default __webpack_public_path__ + "static/privacy-dbf5b092a65cac7100bb014fcbc3849b.svg";